<h1 mat-dialog-title *ngIf="title">{{ title }}</h1>
<button test-id="modal-close-button" mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<div *ngIf="isLoading" class="loading">
  <mat-spinner diameter="40"></mat-spinner>
  <span>{{ 'common.labels.loading' | translate }}</span>
</div>
<iframe *ngIf="iframeSrc" [src]="iframeSrc" (load)="onLoadIframe()" [ngClass]="{ loaded: !isLoading }"></iframe>
